export default "__VITE_ASSET__qZyCoC7l__"